import { z } from 'zod';
// Conexiones externas que la app monitorea (01/10/2026): el 30/09 el token de
// Buffer venció y nadie se enteró durante 2 días — un video quedó sin publicar
// en TikTok mientras YouTube seguía andando. Esta pantalla y sus notificaciones
// son la respuesta: una prueba real por conexión, con una campanita si falla.
//
// Alcance: solo las que el backend llama directo con sus propias credenciales.
// El bot de Telegram y el OAuth de YouTube para subir video viven solo en n8n,
// fuera de este alcance (decisión explícita, no se duplica el token de n8n acá).
// Debe mantenerse en sync con el enum CodigoConexion de Prisma, con UNA excepción:
// NOTION sigue en el enum (su fila histórica en conexion_externa) pero ya no se
// muestra ni se prueba: la app dejó de usar Notion en la fase 9 de la unificación.
export const CODIGOS_CONEXION = [
    'GOOGLE_DRIVE',
    'YOUTUBE',
    'GEMINI',
    'META_ADS',
    'EVOLUTION',
    'BUFFER',
];
// Debe mantenerse en sync con el enum EstadoConexion de Prisma.
export const ESTADOS_CONEXION = ['OK', 'ERROR', 'SIN_PROBAR'];
export const conexionPublicSchema = z.object({
    codigo: z.enum(CODIGOS_CONEXION),
    estado: z.enum(ESTADOS_CONEXION),
    // Última vez que se le pidió una prueba real (botón o job diario).
    ultimaProbada: z.string().nullable(),
    // Última vez que un uso real de la app (no una prueba) tuvo éxito — si es de
    // hoy, el job diario no vuelve a probar (atajo pedido por Javier, 01/10/2026).
    ultimoUsoExitoso: z.string().nullable(),
    detalleError: z.string().nullable(),
});
export const probarConexionesRespuestaSchema = z.object({
    conexiones: z.array(conexionPublicSchema),
});
//# sourceMappingURL=conexion.js.map